import { EcsClient } from './EcsClient';
import { getFluidEcsClientConfiguration } from './utilities';
/**
 * A SettingsProvider class that uses ECS as a cloud service
 */
export class EcsSettingsProvider {
    constructor(ecsSettingsProviderConfiguration, logger) {
        this.ecsClient = new EcsClient(getFluidEcsClientConfiguration(ecsSettingsProviderConfiguration), logger);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.ecsClient.fetch();
    }
    get SettingsProvider() {
        return this;
    }
    /**
     * Reading the setting's value from ECS using the internal `EcsClient`.
     * @param settingName The name of the setting to read from ECS.
     * @param defaultValue The default value in case ECS is not serving the setting or the ECS fetch hasn't finished.
     * @param namespace Used to specify the ECS team's name of the setting we are trying to read.
     * @returns The setting's value to be used by the caller.
     */
    getSetting(settingName, defaultValue, namespace) {
        return this.ecsClient.getSetting(settingName, defaultValue, namespace);
    }
}
//# sourceMappingURL=EcsSettingsProvider.js.map